/* eslint-disable react/jsx-props-no-spreading */
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Spacings } from '@styles/index';
import { buttonTypes } from './scheduleHelper';
import { Live, Play } from './CardIcons';

const Moveup = keyframes`
  from { opacity: 0; top: 50%; }
  to { opacity: 1; top: ${Spacings.SPACING_0B}; }
`;

const Fadeout = keyframes`
  from { opacity: 1; top: ${Spacings.SPACING_0B}; }
  to { opacity: 0; top: ${Spacings.SPACING_0B}; }
`;

const animationNameStepMap = {
  0: '',
  1: Moveup,
  2: Fadeout
};

const IconWrapper = styled.div`
  position: absolute;
  z-index: 1;
  opacity: 0;
  border-radius: 40%;
  right: ${Spacings.SPACING_0B};
  animation-name: ${({ $step }) => animationNameStepMap[$step] || ''};
  animation-duration: 400ms;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
  background-color: var(--color-base-1);
`;

const AnimatedIcon = ({ showButton, _renderIcon }) => {
  const [step, setStep] = useState(0);
  useEffect(() => {
    if (step !== 0 || showButton) setStep(showButton ? 1 : 2);
  }, [showButton, step]);
  const onAnimationEnd = () => {
    if (step === 2) setStep(0);
  };
  return (
    <IconWrapper $step={step} onAnimationEnd={onAnimationEnd}>
      {_renderIcon()}
    </IconWrapper>
  );
};

AnimatedIcon.propTypes = {
  showButton: PropTypes.bool.isRequired,
  _renderIcon: PropTypes.func.isRequired
};

const buttonTypeImageMap = {
  [buttonTypes.live]() {
    return Live;
  },
  [buttonTypes.completed](showButton) {
    return (
      <AnimatedIcon
        showButton={showButton}
        _renderIcon={() => {
          return Play;
        }}
      />
    );
  }
};

const CardIcon = ({ buttonType, showButton }) => {
  return buttonTypeImageMap[buttonType]
    ? buttonTypeImageMap[buttonType](showButton)
    : null;
};

CardIcon.propTypes = {
  buttonType: PropTypes.number.isRequired,
  showButton: PropTypes.bool.isRequired
};

export default CardIcon;
